import { LIMPAR_MAPA_ITINERARIO_VOLTA } from '../types'

export default function limparMapaVeiculoItinerarioVolta () {
  return {
    type: LIMPAR_MAPA_ITINERARIO_VOLTA
  }
}
